import axios from '@/axios'
import store from '../storevuex'
import Swal from 'sweetalert2/dist/sweetalert2'

export function Login ({ next, to }) {
  try {
    axios.get('/auth/checkauth').then(function (res) {
      const FormName = 'UpdateProfile'
      const data = res.data
      store.dispatch('changeConfig', data.result)
      store.dispatch('changeFlag', data.result.MustUpdateProfile)

      if (to.name !== FormName) {
        if (data.result.MustUpdateProfile) {
          Swal.fire({
            title: 'Update Data',
            text: 'Please update your data',
            icon: 'warning',
            showCancelButton: false,
            confirmButtonText: 'Click Here',
            backdrop: true,
            allowOutsideClick: false
          }).then(res => {
            if (res.dismiss === Swal.DismissReason.backdrop) {
              return
            }
            if (res.value) {
              if (to.name !== FormName) {
                next({ name: FormName })
              }
            }
          })
        }
      }

      // store.dispatch('changeFlag', false)
      if (!data.status) {
        localStorage.removeItem('token')
        console.log('next to the login router')
        next({ name: 'Login' })
      }

      if (data.result.ProfileComplete < 80) {
      // next({ name: 'Profile', query: { update: 'required' } })
      }
    })
  } catch (e) {
    next({ name: 'Login' })
  }

  next()
}



// WEBPACK FOOTER //
// ./src/middleware/auth.js